import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { FormTitle } from "../members/formComponents/FormTitle"
import { FormButton } from "../members/formComponents/FormButton"
import { Redirect } from "react-router-dom"
import {
  Container,
  ListGroup,
  ListGroupItem,
  Row,
  Col,
  Alert,
  Input,
} from "reactstrap"
import { Trans, useLingui } from "@lingui/react"
import uuid from "uuid"
import { toast } from "react-toastify"
import {
  WarningMessage,
} from "../../view/shared/notifications/Notifications"
import { getCurrency } from "../../view/shared/utilities/currency"
import { reverseTransaction } from "../../store/reducers/transactions/actions"
import { intToArabic } from "../../view/shared/utilities/arabicNumParser"
import { setCurrentPage } from "../../store/reducers/navigation"
import StellarLoader from "../layout/StellarLoader"

const LastSharesSold = (props) => {
  const { i18n } = useLingui()

  const [state, setState] = useState({
    reverse: false,
    loading: false,
    redirect: false,
  })
  const dispatch = useDispatch()
  const { ongoingMeeting, vsla, currentMember, group } = useSelector((state) => ({
    ongoingMeeting: state.meeting?.ongoing,
    vsla: state.vsla,
    currentMember: state.loadedMember,
    group: state.group,
  }))

  const notify = (msg) => toast(msg)

  const onChange = (e) => {
    const lang_code = i18n.locale

    const lang = {
      fr: {
        message: `Confirmez que vous souhaitez activer l'annulation des transactions`,
      },
      en: {
        message: `Confirm you want to activate reversal of transactions`,
      },
      sw: {
        message: `Thibitisha unataka kuwezesha kurejeshea mwanachama mchango`,
      },
      es: {
        message: `Confirme que desea activar la reversión de transacciones`,
      },
      lb: {
        message: `Confirm you want to activate reversal of transactions`,
      },
      pt: {
        message: `Confirme que deseja ativar o estorno de transações`,
      },
      ar: {
        message: "أكد أنك تريد تفعيل إلغاء المعاملات",
      },
    }

    if (window.confirm(lang[lang_code].message)) {
      setState((prevState) => ({
        ...prevState,
        [e.target.name]: toggleReverse(),
      }))
    }
  }

  const reverse = (data) => {
    const uid = currentMember.pubkey
    const lang_code = i18n.locale
    const amount = data.amount.toString()
    const lang = {
      fr: {
        message: `Confirmer la cotisation de ${amount} pour le membre`,
      },
      en: {
        message: `Confirm reversal of ${amount} for member`,
      },
      sw: {
        message: `Thibitisha kurejeshea mwanachama mchango wa shilingi ${amount}`,
      },
      es: {
        message: `Confirmar la reversión de ${amount} lempiras por miembro`,
      },
      lb: {
        message: `Confirm reversal of ${amount} for household`,
      },
      pt: {
        message: `Confirme o reverso de ${amount} para o membro`,
      },
      ar: {
        message: `${amount} أكد عكس معاملة المبلغ`,
      },
    }

    if (window.confirm(lang[lang_code].message)) {
      dispatch(reverseTransaction({ ...data, uid }, props.offlineMeeting))
      notify(<WarningMessage msg={"Processing Reversal"} />)
      dispatch(setCurrentPage("group-memberList"))
    }
  }

  const toggleReverse = () => {
    return !state.reverse
  }

  const { transactions, member } = props
  const { loading, redirect } = state

  const headerStyle = {
    color: "#E36F1E",
    fontFamily: "quicksand",
    fontWeight: "bolder",
    fontSize: "1.2rem",
    textAlign: "center",
    paddingBottom: "0.5em",
  }

  const listStyle = {
    color: "#343a40",
    fontFamily: "Fira Sans",
    fontSize: "20px",
    textAlign: "left",
  }

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: `/Groups/${vsla?.id}/members/${member.id}/Actions`,
          state: { vsla_id: vsla?.id },
        }}
      />
    )
  }

  if (loading) {
    return <StellarLoader />
  }

  if (ongoingMeeting && transactions.length < 1) {
    return (
      <div>
        {" "}
        <Alert color="warning">
          <span>
            <Trans id="notifications.no_reversible_transactions">
              No reversible transactions found
            </Trans>
          </span>
        </Alert>
      </div>
    )
  }

  if (ongoingMeeting) {
    return (
      <Container>
        <FormTitle style={headerStyle} title={i18n._("Last Transaction")} />
        <ListGroup flush>
          {transactions.map((txn) => {
            return (
              <ListGroupItem style={listStyle} key={uuid.v4()}>
                <Row>
                  <Col>
                    <span>
                      {i18n.locale === "ar"
                        ? intToArabic(txn.amount)
                        : txn.amount}{" "}
                      {!["ar", "lb"].includes(i18n.locale) &&
                        getCurrency(group?.country).symbol}
                      {["ar", "lb"].includes(i18n.locale) &&
                        (vsla?.metadata?.currency === "USD"
                          ? getCurrency(group?.country).usd_symbol
                          : getCurrency(group?.country).lbp_symbol)}
                    </span>
                  </Col>
                  <Col>
                    <FormButton
                      handleClick={() => reverse(txn)}
                      value={i18n._("Reverse")}
                      className="btn btn-lg form-control float"
                      disabled={state.reverse ? false : true}
                    />
                  </Col>
                </Row>
              </ListGroupItem>
            )
          })}
        </ListGroup>
        <Container>
          <Input
            name="reverse"
            type="checkbox"
            value={state.reverse}
            onChange={onChange}
            checked={state.reverse ? true : false}
          />
          <Alert color="warning">
            <span>
              <Trans id="notifications.activate_reversible_transactions">
                Check the box to activate reversal of transactions
              </Trans>
            </span>
          </Alert>
        </Container>
      </Container>
    )
  }

  return <div></div>
}

LastSharesSold.propTypes = {
  offlineMeeting: PropTypes.object,
  member: PropTypes.object,
  transactions: PropTypes.array,
}

export default LastSharesSold
